import React, { useState, useEffect, useRef, useCallback } from 'react';
import io from 'socket.io-client';
import Message from './Message';
import Popup from './Popup';
import '../styles/ChatBox.css';
import axios from 'axios'
import {  MdOutlineFileDownload } from "react-icons/md";
import { jsPDF } from "jspdf"; // For PDF generation
import { RiChatNewLine } from "react-icons/ri";
import loadingGif from '../assets/Loving-Is-Loading-gif.gif'
import { useNavigate,useParams } from 'react-router-dom';
import ChatModeSelectionModal from './ChatModeSelectionModal';
import {FiHeart, FiMessageSquare} from "react-icons/fi"
import { HiArrowSmUp } from "react-icons/hi";


const SOCKET_SERVER_URL = process.env.REACT_APP_BACKEND_URL;
const API_SERVER_URL = `${SOCKET_SERVER_URL}/api/chats`;

const AnswerModeChatBox = ({ userId }) => {
    const [socket, setSocket] = useState(null);
    const [chats, setChats] = useState([]);
    const [selectedChatId, setSelectedChatId] = useState(null);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(true);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [chatMode, setChatMode] = useState('answerChat'); // New state for selected chat mode
        const { chatId: urlChatId } = useParams();
    const [loadingChatId, setLoadingChatId] = useState(null);

    const messagesEndRef = useRef(null);
    const [chatNameUpdated, setChatNameUpdated] = useState(false);  
    const messageRef = useRef(null);
        const [loadingMessage, setLoadingMessage] = useState(false);
const [pendingMessage, setPendingMessage] = useState(null); // Store message until selectedChatId updates
const navigate = useNavigate()



        const getHeading = () => {
            const element = messageRef.current;
            if (!element) return "Untitled";
        
            const headings = element.querySelectorAll("h1, h2, h3, h4, h5, h6");
            return headings.length > 0 ? headings[0].textContent.trim() : "Untitled";
          };
          const addFooter = (doc, pageHeight, margin) => {
            doc.setFontSize(10);
            doc.setFont("Helvetica", "italic");
            doc.text(`Generated on ${new Date().toLocaleDateString()}`, margin, pageHeight - 10);
          };
      const handleDownloadPDF = () => {
        const doc = new jsPDF();
        const heading = getHeading(); // Get the heading to use in the filename and as the title
    
        // Set the document title (heading as the title)
        doc.setFontSize(18);
        doc.setFont("Helvetica", "bold");
        doc.text(heading, 10, 20); // Title at the top of the page
    
        const element = messageRef.current;
        if (!element) {
          console.error("Message content is not available!");
          return;
        }
    
        const pageHeight = doc.internal.pageSize.height;
        const margin = 10;
        let yPosition = 30;
    
        const messageContent = element.innerText.trim();
        const lines = messageContent.split("\n").map(line => line.trim());
        const maxLineWidth = 180; // Adjust for page width and margins
    
        lines.forEach((line) => {
          if (line === "") {
            yPosition += 5; // Add spacing for empty lines
            return;
          }
    
          // Add new page if the text exceeds the current page
          if (yPosition + 10 > pageHeight - margin) {
            addFooter(doc, pageHeight, margin);
            doc.addPage();
            yPosition = margin + 10;
          }
    
          // Bold for headings (example: lines starting with keywords like "Main:")
          if (line.startsWith("Main:")) {
            doc.setFontSize(14);
            doc.setFont("Helvetica", "bold");
            doc.text(line.replace("Main:", "").trim(), margin, yPosition);
            yPosition += 10;
          } else {
            // Normal text for other lines
            doc.setFontSize(12);
            doc.setFont("Helvetica", "normal");
            const wrappedText = doc.splitTextToSize(line, maxLineWidth);
            wrappedText.forEach((wrappedLine) => {
              if (yPosition + 10 > pageHeight - margin) {
                addFooter(doc, pageHeight, margin);
                doc.addPage();
                yPosition = margin + 10;
              }
              doc.text(wrappedLine, margin, yPosition);
              yPosition += 8; // Regular line height
            });
          }
        });
    
        
        // Final footer and save
        addFooter(doc, pageHeight, margin);
        doc.save(`${heading}.pdf`);
      };
      const handleChatModeSelect = (mode) => {
        setChatMode(mode);
        setIsModalOpen(false);
        setSelectedChatId(null); // Reset selected chat when switching modes
        setMessages([]); // Clear messages
        
        if (mode === 'answerChat') {
            setIsPopupOpen(true);
            navigate('/answer-chat');
        } else {
            navigate('/chat')
        }
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    // Initialize socket connection
    useEffect(() => {
        if (!userId) return;
      
        // Create a new socket connection.
        const newSocket = io(SOCKET_SERVER_URL, { transports: ['websocket'] });
        setSocket(newSocket);
      
        // Define handlers.
        const handleConnect = () => {
          console.log('Socket connected:', newSocket.id);
        };
      
        const handleDisconnect = () => {
          console.log('Socket disconnected');
        };
      
        const handleConnectError = (error) => {
          console.error('Socket connection error:', error);
        };
      
        // Attach event listeners.
        newSocket.on('connect', handleConnect);
        newSocket.on('disconnect', handleDisconnect);
        newSocket.on('connect_error', handleConnectError);
      
        // Clean up on unmount or when userId changes.
        return () => {
          newSocket.off('connect', handleConnect);
          newSocket.off('disconnect', handleDisconnect);
          newSocket.off('connect_error', handleConnectError);
          newSocket.close();
        };
      }, [userId]);
      

    // Fetch all chats
    useEffect(() => {
        const fetchChats = async () => {
          if (!userId) return;
    
          try {
            const response = await fetch(`${API_SERVER_URL}/getChats?userEmail=${userId}`);
            const data = await response.json();
            const chatList = Array.isArray(data?.chats) ? data.chats : [];
    
            setChats((prevChats) => {
              const updatedChats = [...chatList, ...prevChats];
              return [...new Map(updatedChats.map((chat) => [chat.chatId, chat])).values()]
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            });
    
            if (chatList.length === 0) {
              // Open the popup if there are no existing chats
              setIsPopupOpen(true);
            } else {
              // Determine which chat to select:
              // 1. If URL has chatId, use it.
              // 2. Otherwise, check localStorage.
              // 3. Otherwise, pick the latest chat.
              if (urlChatId) {
                setSelectedChatId(urlChatId);
                localStorage.setItem('selectedChatId', urlChatId);
                fetchChatHistory(urlChatId);
              } else {
                const storedChatId = localStorage.getItem('selectedChatId');
                if (storedChatId) {
                  setSelectedChatId(storedChatId);
                  navigate(`/answer-chat/${storedChatId}`, { replace: true });
                  fetchChatHistory(storedChatId);
                } else {
                  const sortedChats = chatList.sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                  );
                  const latestChat = sortedChats[0];
                  if (latestChat) {
                    setSelectedChatId(latestChat.chatId);
                    localStorage.setItem('selectedChatId', latestChat.chatId);
                    navigate(`/answer-chat/${latestChat.chatId}`, { replace: true });
                    fetchChatHistory(latestChat.chatId);
                  }
                }
              }
            }
          } catch (error) {
            console.error('Error fetching chats:', error);
          }
        };
    
        fetchChats();
      }, [userId, urlChatId, navigate]);
    // Fetch chat history
    const fetchChatHistory = async (chatId) => {
        if (!chatId) return;
        try {
            const response = await fetch(`${API_SERVER_URL}/getChatHistory/${chatId}`);
            const data = await response.json();
            const chatMessages = data.messages?.messages || [];
            setMessages(chatMessages);
        } catch (error) {
            console.error('Error fetching chat history:', error);
        }
    };


    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);

    // Initialize a new chat
    const initializeChat = async (formData) => {
        if (isLoading || !socket) return null;
      
        setIsLoading(true);
        try {
          const chatName = formData?.question1 
            ? `${formData.question1.slice(0, 20)}`
            : `Chat ${chats.length + 1}`;
      
          return new Promise((resolve, reject) => {
            socket.emit('initChat', { 
              isGuest: false, 
              userEmail: userId, 
              name: chatName,
              mode: 'answerChat' // Explicit mode for AnswerChat
            }, (response) => {
              setIsLoading(false);
      
              if (response?.chatId) {
                const newChat = {
                  chatId: response.chatId,
                  name: chatName,
                  createdAt: new Date().toISOString(),
                  mode: 'answerChat'
                };
      
                setChats(prev => [newChat, ...prev]);
                setSelectedChatId(response.chatId);
                localStorage.setItem('selectedChatId', response.chatId);
                navigate(`/answer-chat/${response.chatId}`, { replace: true });
                resolve(response.chatId);
              } else {
                reject(response?.error || 'Initialization failed');
              }
            });
          });
        } catch (error) {
          console.error('Error initializing chat:', error);
          setIsLoading(false);
          return null;
        }
      };
      const handlePopupClose = () => {
        setIsPopupOpen(false);
        // Don't create any chat here - wait for user action
      };
            
      const sendMessage = async (chatId, message) => {
        if (!message || !chatId || !socket) return;
      
        const trimmedMessage = message.trim();
        const userMessage = { 
          role: 'user', 
          content: trimmedMessage, 
          createdAt: new Date().toISOString() 
        };
      
        setMessages(prev => [...prev, userMessage]);
        setLoadingChatId(chatId);
        const currentChat = chats.find((chat) => chat.chatId === chatId);
        const currentMode = currentChat ? currentChat.mode : chatMode;

        const socketEvent = currentMode === 'answerChat' ? 'answerChatMode' : 'sendMessage';


      
        return new Promise((resolve) => {
            socket.emit(
          socketEvent,
          { chatId, message: trimmedMessage },
          async (response) => {
            setLoadingChatId(null);
            if (response?.error) {
              setMessages((prevMessages) => [
                ...prevMessages,
                { role: 'assistant', content: 'Oops seems like the AI went on a coffee break. Let me try getting them getting a hold of them again.' },
              ]);
            } else {
              setMessages((prevMessages) => [
                ...prevMessages,
                {
                  role: 'assistant',
                  content: response.message,
                  createdAt: new Date().toISOString(),
                },
              ]);
      
              // Rename chat after first message
              const chat = chats.find(c => c.chatId === chatId);
              if (chat && chat.name.startsWith('Chat')) {
                const newName = trimmedMessage.slice(0, 20);
                updateChatName(chatId, newName);
              }
            }
            resolve();
          });
        });
      };

      const updateChatName = async (chatId, newName) => {
        try {
            const response = await axios.put(`${API_SERVER_URL}/${chatId}/name`, { newName });
    
            if (response.status === 200) {
                console.log('Chat name updated successfully:', response.data);
                // Update the chat name in the state after successful API call
                setChats((prevChats) =>
                    prevChats.map((chat) =>
                        chat.chatId === chatId ? { ...chat, name: newName } : chat
                    )
                );
                setChatNameUpdated(true); // Set the flag that chat name has been updated
            } else {
                console.error('Failed to update chat name:', response.status, response.data);
                throw new Error('Failed to update chat name');
            }
        } catch (error) {
            console.error('Error in API call to update chat name:', error.message);
            throw error; // Rethrow the error to be handled by the calling function
        }
    };
      useEffect(() => {
        if (pendingMessage && selectedChatId) {
          sendMessage(selectedChatId, pendingMessage);
          setPendingMessage(null);
        }
      }, [selectedChatId, pendingMessage]);
    

    useEffect(() => {
        if (chatNameUpdated) {
            // Action after chat name is updated, e.g., logging
            console.log('Chat name was updated successfully!');
            setChatNameUpdated(false); // Reset the flag after handling
        }
    }, [chatNameUpdated]); 

    const handlePopupSubmit = async (formData) => {
        if (!formData?.question1) return;
      
        try {
          const chatId = await initializeChat(formData);
          if (chatId) {
            setIsPopupOpen(false);
            // Set pending message to trigger send after chatId is set
            setPendingMessage([
              formData.question1,
              formData.question2,
              formData.question3
            ].filter(Boolean).join(', '));
          }
        } catch (error) {
          console.error('Error creating chat:', error);
        }
      };

    
    const handleKeyPress = (e) => {
        // Check if the Enter key was pressed (keyCode 13)
        if (e.key === 'Enter' && !e.shiftKey) {
            // Trigger form submission
            e.preventDefault(); // Prevents a new line
            handleChatboxSubmit(e);
            setInput('')
        }
    };
    const handleChatboxSubmit = async (e) => {
        e.preventDefault();
        const message = input.trim();
        if (!message) return;
      
        try {
          // Create chat if none exists
          let targetChatId = selectedChatId;
          if (!targetChatId) {
            targetChatId = await initializeChat({
              question1: message, // Use message as initial question
              question2: '',
              question3: ''
            }, false); // Disable pending messages
          }
          
          // Send the actual user message
          await sendMessage(targetChatId, message);
          setInput('');
        } catch (error) {
          console.error('Message sending failed:', error);
        }
      };
      

    const handleAddChat = () => {
        setSelectedChatId(null);
        setIsPopupOpen(true);
    };


    const handleSelectChat = async (chatId) => {

        setMessages([]);
        setLoadingChatId(null);
        
        setSelectedChatId(chatId);
        localStorage.setItem('selectedChatId', chatId);

        const currentChat = chats.find((chat) => chat.chatId === chatId);
        const currentMode = currentChat ? currentChat.mode : chatMode;

        navigate(`/answer-chat/${chatId}`);
      
        // Load new chat's history
        await fetchChatHistory(chatId);
      };

    const formatDateTime = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };


  const ChatModeIcon = ({ mode }) => {
    if (mode === 'standard') {
      return <FiHeart className="chat-mode-icon" size={16} />;
    }
    if (mode === 'answerChat') {
      return <FiMessageSquare className="chat-mode-icon-answer" size={16} />;
    }
    return null;
  };
    return (
        <div className="chat-container">
            <div className="sidebar">
                <button className="add-chat-button"  onClick={() => setIsModalOpen(true)} disabled={isLoading}>
                 <RiChatNewLine size={20} color="black" />
                    
                </button>

                <div className="chat-list">
                {chats.map((chat) => (
    <div
      key={chat.chatId}
      className={`chat-item ${chat.chatId === selectedChatId ? 'active' : ''}`}
      onClick={() => handleSelectChat(chat.chatId)}
    >
      <div className="chat-item-header">
        <ChatModeIcon mode={chat.mode} />
        <div className="chat-name">{chat.name}</div>
      </div>
      <div className="chat-date">{formatDateTime(chat.createdAt)}</div>
    </div>
  ))}
            </div>
        </div>
        
        {isModalOpen && <ChatModeSelectionModal onSelect={handleChatModeSelect} onClose={handleModalClose} />}
        
            <div className="chat-area">
                <div className="messages">
                    {messages.map((msg, index) => (
                        <Message key={index} sender={msg.role} text={msg.content} />
                    ))}
                        {loadingMessage && (
                            <div className="message loading">
                                <img src={loadingGif} alt="Loading..." />
                            </div>
                        )}
                    <div ref={messagesEndRef} />
                </div>

            <form className="input-area" onSubmit={handleChatboxSubmit}>
                <div className="input-wrapper-chat">
                    <textarea
                        value={input}
                        onKeyDown={handleKeyPress}

                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Message LovingIS"
                        rows="1"
                        className="dynamic-textarea"
                    />
                    <button className="enter-button" type="submit" disabled={!input.trim() || isLoading}>
                     <HiArrowSmUp size={24} />
                        
                    </button>
                </div>
                <button onClick={handleDownloadPDF} className="download-button-fullchat">
                    <MdOutlineFileDownload size={34} color="coal" />
                </button>
            </form>
            </div>

            {isPopupOpen && (
                <Popup
                    onClose={() => {setIsPopupOpen(false)
                        handlePopupClose()
                    }}
                    onSubmit={(formData) => handlePopupSubmit(formData)}
                />
            )}
        </div>
    );
};

export default AnswerModeChatBox;